<template>
  <div class="h-dialogContainer">
    <form id="uploadNoRealTaskDialog">
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.startTime')}}:</div>
          <ejs-datetimepicker
            :format='dateFormat'
            :allowEdit=false
            :change="validateOfUploadDialog"
            name="startTime"
            :locale='locale'
            step='5'
            timeFormat="HH:mm:ss"
            v-model='startTime'
          ></ejs-datetimepicker>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.endTime')}}:</div>
          <ejs-datetimepicker
            :format='dateFormat'
            :allowEdit=false
            :change="validateOfUploadDialog"
            name="endTime"
            step='5'
            timeFormat="HH:mm:ss"
            :locale='locale'
            v-model='endTime'
          ></ejs-datetimepicker>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";

  export default {
    name: 'UploadNoRealTaskDialog',
    data() {
      return {
        locale: localStorage.getItem('locale'),
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        startTime: null,
        endTime: null,
        uploadDialogValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            startTime: {
              required: [true, this.$t('Pm.begTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.begTimeFormatError')]
            },
            endTime: {
              required: [true, this.$t('Pm.endTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.endTimeFormatError')]
            }
          }
        },
        formObjOfUploadDialog: ''
      }
    },
    methods: {
      bindValidateOfUploadDialog(){
        this.formObjOfUploadDialog = new FormValidator('#uploadNoRealTaskDialog', this.uploadDialogValidation);
      },
      validateOfUploadDialog() {
        const formStatus = this.formObjOfUploadDialog.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      },
    },
    mounted() {
      this.bindValidateOfUploadDialog();
    }
  }
</script>

<style scoped>
</style>
